var Bg = "/static/3bb25ac57cea3b1e.png";

export { Bg as default };
//# sourceMappingURL=bottom_gradient.png.js.map
